module.exports = __webpack_public_path__ + "static/media/loginLogo.671ee9f4.svg";